export const SITE_URL = "readybusinessdr.maximquiz.com";
